import barba from '@barba/core';

/*--------------------
Vars
--------------------*/
let speed = 0;
let acc = 0;
let hover = false;
let height;
// let times;
// let cloned = [];

let item = document.querySelector( '#title-inner-wrapper' );
// const word = item.querySelector( '#title-inner__text' );


/*--------------------
Calculate
--------------------*/
export const calculateTitle = () => {
  let item = document.querySelector( '#title-inner-wrapper' );
  const itemsCount = 20;
  const itemsWidth = item.offsetWidth;
  const itemWidth = itemsWidth / itemsCount;
  height = itemWidth * ( itemsCount - 10 );
};


/*--------------------
Listeners
--------------------*/
const handleMouse = bool => hover = bool;
item.addEventListener( 'mouseenter', () => {
  handleMouse( true );
} );
item.addEventListener( 'touchstart', () => {
  handleMouse( true );
} );
item.addEventListener( 'mouseleave', () => {
  handleMouse( false );
} );
item.addEventListener( 'touchend', () => {
  handleMouse( false );
} );
window.addEventListener( 'resize', calculateTitle );
window.addEventListener( 'load', calculateTitle );
barba.hooks.beforeEnter((data) => {
  calculateTitle();
});


/*--------------------
Animate
--------------------*/
const animate = () => {
  // Acceleration
  acc += 0.05;
  if ( hover ) {
    acc -= 0.35;
  }

  // Min/Max accelearion
  acc = Math.min( 0.2, Math.max( 0, acc ) );

  // Add acceleration to speed
  speed += acc;

  // Text Loop
  if ( speed >= height ) {
    speed = 0;
  }

  // CSS Text
  item.style.transform = `translateX(${ -speed }px)`;

  // RaF
  requestAnimationFrame( animate );
};

animate();
